import React from "react";
import { captureMessage } from "@sentry/react";
import { LoadingPage, PageLoadingWrapper } from "~/components";

// Because RR treats paths with a `/` prefix as an absolute path, we need to
// remove it for relative paths.
export function rrPath(path: string): string {
  if (path === "/") return path;

  return path[0] === "/" ? path.slice(1) : path;
}

// The type expected is a React FC, but in this case we are just forcing a reload
const forceReload = (e: any): any => {
  captureMessage("Error loading a lazy component", {
    extra: { error: e },
  });
  console.log("Force reloading the page due to an error.");

  window.location.reload();
};

export const lazy = (component: React.ReactNode): JSX.Element => {
  return (
    <React.Suspense fallback={<LoadingPage />}>
      <PageLoadingWrapper>{component}</PageLoadingWrapper>
    </React.Suspense>
  );
};

const lazyLoadFactory = (filePath: string) => (fileName: string) => {
  // Format required by https://github.com/rollup/plugins/tree/master/packages/dynamic-import-vars#limitations
  const importer = () =>
    import(`../${filePath}/pages/${fileName}/${fileName}.tsx`).catch(
      forceReload,
    );

  return React.lazy(importer);
};

export const lazyLoadMemberPages = lazyLoadFactory("MemberApp");

export const lazyLoadLandingPages = lazyLoadFactory("LandingApp");
